var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fa-stack fa-3x",style:(_vm.stepStyle)},[_c('i',{class:_vm.active?_vm.iconActiveClass:_vm.iconInActiveClass}),_c('strong',{class:_vm.active?_vm.numberActiveClass:_vm.numberInActiveClass},[_vm._v(_vm._s(_vm.stepNumber))])])
}
var staticRenderFns = []

export { render, staticRenderFns }